export default __webpack_public_path__ + "static/media/7t.8400e4b1.jpg";